export function encodeToBase64(num) {
  // Convert the integer to a string (or binary representation if needed)
  const buffer = new TextEncoder().encode(num.toString());

  // Encode the buffer as a Base64 string
  const base64Encoded = btoa(String.fromCharCode(...buffer));

  return base64Encoded;
}
